<template>
    <div class="followUserWrap">
        <div class="followUserMain">
            <div class="followHeader">
                <div class="followLeft">
                    <p>关注Ta的也关注</p>
                </div>
                <div class="followRight">
                    <button class="followReload" @click.stop.prevent="reloadList">换一换</button>
                    <button class="followClose" @click.stop.prevent="closeToast"></button>
                </div>
            </div>
            <div class="followBody">
                <div
                    class="followLi"
                    v-for="(item, index) in userListFn"
                    :key="index"
                >
                    <div
						class="followAvatar"
						@click.stop.prevent="goDetail(item)"
					>
                        <img :src="item.image" alt="">
						<i 
							v-for="(imgItem, imgIndex) in item.user_medals_tail"
							:key="imgIndex"
							:style="{
								backgroundImage: `url(${imgItem.image})`
							}"
						></i>
                    </div>
                    <div class="followInfo">
                        <h1>{{item.title}}</h1>
                        <p>{{item.intro}}</p>
                    </div>
                    <div class="followBtn">
                        <button :class="[{
                            isFollow: item && item.isFollow && item.isFollow == 'yes'
                        }]" @click.stop.prevent="followUser(item, index)">{{item.isFollow == 'yes'? "已关注": "关注"}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isLoginInfo  } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
import { u_id } from "@/utils/urlQuery";
export default {
    name: "followUserCard",
    data() {
        return {
            userList: [], // 关注的用户列表
            page: 1, //
            step: 3, //
            total: 0
        }
    },
    created() {
        // 获取推荐列表
        this.getPcRecommend();
    },
    methods: {
        // 获取推荐列表
        async getPcRecommend() {
            let res = await userHomeApi.getPcRecommend({
                page: 1,
                pagesize: 21
            })
            if(res.status == "success"){
                let result = res.data;
                if(result && result.length > 0) {
                    this.userList = result;
                }
            }
        },
        // 点击关注用户
        async followUser(item, index) {
			if(!isLoginInfo()) {
				return
			}
            let _type = (!item.isFollow || item.isFollow == 'no');
			let ApiName = "", Query = { act: _type? "follow" : "unfollow"};
			if(item.kind == 'live' || item.kind == 'liver') {
				ApiName = "setFollowLive"
				Query.id = item.id;
			} else {
				ApiName = "setFollowUser";
				Query.u_id_m = item.id;
				Query.u_id_s = u_id;
			}
            let res = await userHomeApi[ApiName](Query)
            if(res.rslt == 'succ') {
                this.$set(this.userList[((this.page - 1) * this.step) + index], 'isFollow', _type?"yes": "no")
            }
        },
        // 点击切换按钮刷新本地数据
        reloadList() {
            let count = this.userList.length;
            let page = this.page, step = this.step;
            page+=1;
            if(page * step > count) {
                this.page = 1;
            } else {
                this.page = page;
            }
        },
        // 点击关闭弹窗
        closeToast() {
            this.$parent.showFollowCard = false;
        },
		// 跳转用户主页
		goDetail(item) {
			console.info(item, "ITEM")
			this.openNative('person_page',{
			  id: item.id,
			  o_kind: item.kind == 'live'? 'live_msg': 'user_msg',
			})
		},
		
		// 跳转APP页面
		openNative(type, query = {}) {
		    let params = {
		        kind: type, // 类型
		    };
		
		    // 同步传参
		    params = {
		        ...params,
		        ...query
		    }
		
		    switch(type) {
		        case "person_page":
		            break;
		    }
		
		    this.$srH5CallNativeMethodApp('call_Native',params)
		},
    },
    computed: {
        userListFn() {
            let list = this.userList || [], page = this.page, step = this.step;
            if(list && list.length > 0) {
                list = JSON.parse(JSON.stringify(list));
                return list.slice((page - 1) * step, page * step)
            } else {
                return list;
            }
        }
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.followUserWrap {
    width: auto;
    height: rem2(230px);
    background-color: #fff;
    padding: rem2(6px) rem2(12px) rem2(12px);
    box-sizing: border-box;

    .followUserMain {
        border: rem2(1px) solid #ebebeb;
        border-radius: rem2(6px);
        width: 100%;
        height: auto;
        padding: rem2(12px);
        box-sizing: border-box;

        .followHeader {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content:space-between;

            .followLeft {
                p {
                    font-size: rem2(14px);
                    font-weight: 400;
                    line-height: rem2(16px);
                    text-align: justified;
                    color: #333;
                }
            }

            .followRight {
                display: inline-flex;
                flex-direction: row;
                align-items: center;

                .followReload {
                    padding: 0 0 0 rem2(21px);
                    font-size: rem2(13px);
                    font-weight: 400;
                    line-height: rem2(16px);
                    color: #939393;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/followReload.svg");
                    background-repeat: no-repeat;
                    background-size: rem2(16px) rem2(16px);
                    background-position: left center;
                    border: none;
                    outline: none;
                    margin-right: rem2(15px);
                }

                .followClose {
                    width: rem2(18px);
                    height: rem2(18px);
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/followClose.svg");
                    background-repeat: no-repeat;
                    background-size: rem2(16px) rem2(16px);
                    background-position: center center;
                    border: none;
                    outline: none;
                    padding: 0;
                }
            }
        }

        .followBody {
            margin-top: rem2(16px);
            display: flex;

            .followLi {
                flex: 1;
                overflow: hidden;
                margin-right: rem2(8px);
                display: flex;
                flex-direction: column;
                align-items: center;

                &:last-of-type {
                    margin-right: 0;
                }

                .followAvatar {
                    width: rem2(50px);
                    height: rem2(50px);
					position: relative;
                    
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
						border-radius: 50%;
						overflow: hidden;
                        object-fit: cover;
                    }
					
					i {
						position: absolute;
						width: 16px;
						height: 16px;
						border-radius: 50%;
						overflow: hidden;
						right: 0;
						bottom: 0;
						z-index: 2;
						background-repeat: no-repeat;
						background-color: #fff;
						background-size: 12px auto;
						background-position: center;
					}
                }

                .followInfo {
                    margin-top: rem2(8px);
					width: 100%;

                    h1 {
                        font-size: rem2(14px);
                        font-weight: 500;
                        line-height: rem2(16px);
                        text-align: center;
                        color: #333;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    p {
                        max-height: rem2(30px);
                        min-height: rem2(30px);
                        height: rem2(30px);
                        margin-top: rem2(8px);
                        font-size: rem2(11px);
                        font-weight: 400;
                        line-height: rem2(14.85px);
                        text-align: center;
                        color: #636363;
                        overflow: hidden;
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }

                .followBtn {
                    margin-top: rem2(8px);

                    button {
                        width: rem2(66px);
                        height: rem2(30px);
                        border-radius: rem2(4px);
                        padding: 0;
                        border: none;
                        outline: none;
                        background-color: #FF443D;
                        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/followAdd.svg");
                        background-repeat: no-repeat;
                        background-position: rem2(14px) center;
                        background-size: rem2(8px);
                        padding-left: rem2(12px);
                        font-size: rem2(13px);
                        font-weight: 500;
                        color: #fff;

                        &.isFollow {
                            padding: 0;
                            background-image: unset;
                            background-color: #CACACA;
                        }
                    }
                }
            }
        }
    }
}
</style>